import routes from '@/modules/auth/routes'
import store from '@/modules/auth/store'

export default { routes, store }
